/* eslint-disable arrow-body-style */

import React from "react";

// Custom
import modelUser from "@/models/user";
import modelIzlet from "@/models/izlet";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import UserVodicDialog from "@/views/UsersPage/UserVodicDialog";
import HPSIzletForm from "@/views/Izleti/Forms/HPSIzletForm";
import { Permissions } from "@/lib/permissions";

const SPVVodiciPage = () => {

  return (
    <DataCentricPage
      needPermission={[Permissions.HPSStanicaPlanVodicaView, Permissions.Administration]}

      primaryModel={modelUser}
      primaryTitleToken="titles.vodici_spv"
      primaryView="planinarski_vodici"
      primaryAllowAdd={false}
      primaryAllowView
      primaryDialogForm="planinarski_vodic"
      primaryDialogComponent={UserVodicDialog}
      primaryAllowEdit={false}
      primaryOverrideAPIUrl="hps/planinarski-vodici?type=spv"

      secondaryModel={modelIzlet}
      secondaryTitleToken="titles.izleti"
      secondaryView="vodic_izleti"
      secondaryAllowView
      secondaryDialogForm="spv"
      secondaryDialogComponent={HPSIzletForm}
      secondaryAllowEdit={false}

      baseRecordPath="hps/planinarski-vodici"
      childRecordRelativePath="izleti"
      geomRelativePath="izleti-geom"
      
      mapId={10}
      mapModel={modelIzlet}
      miniMapBaseRecordQueryParams="?type=spv"
    />
  );
};

export default SPVVodiciPage;
